import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Root } from "./Root";
import "./styles/site.css";

const container = document.getElementById("root");
const app = <Root Router={BrowserRouter} />;
// Prerendered pages hydrate; the dev server (empty root) renders from scratch.
if (container.firstElementChild) hydrateRoot(container, app);
else createRoot(container).render(app);
